import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import FooterStyles from "./Footer.css";

/* eslint-disable import/no-webpack-loader-syntax */

import FooterIcon from "-!svg-react-loader!../icons/footer-icon.svg";

import FacebookIcon from "-!svg-react-loader!../icons/facebook.svg";
import TwitterIcon from "-!svg-react-loader!../icons/twitter.svg";
import WhatsappIcon from "../icons/whatsapp.png";

import utilities from "./Utilities";
let Utilities = new utilities();

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  createCartItem = () => {
    window.location.href = "/build/size/" + Utilities.createCartItem();
  };

  render() {
    return (
      <div className='footer-container no-print'>
        <div className='main-container'>
          <footer>
            <div className='icon'>
              <FooterIcon />
            </div>
            <div className='links'>
              <ul>
                {/* <li>
                                    <Link onClick={() => { this.createCartItem(); }} to="#">Start Framing</Link>
                                </li> */}
                <li>
                  <Link to='/about-us'>About Us</Link>
                </li>
                <li>
                  <Link to='/contact-us'>Contact Us</Link>
                </li>
                <li>
                  <a
                    target='_blank'
                    href={
                      window.region === "SG"
                        ? "https://blog.frameit.com.sg/"
                        : "https://blog.frameit.my/"
                    }
                  >
                    Help
                  </a>
                </li>
                <li>
                  <Link to='/terms'>Terms</Link>
                </li>
                <li>
                  <Link to='/shipping'>Shipping</Link>
                </li>
                <li>
                  <Link to='/privacy-policy'>Privacy</Link>
                </li>
              </ul>
            </div>
            <div className='social'>
              {window.region === "SG" && (
                <a target='_blank' href='https://www.facebook.com/frameitsg'>
                  <FacebookIcon />
                </a>
              )}
              {/*<Link to="#">
                                <TwitterIcon />
                            </Link>*/}
            </div>
            <div className='terms'>All Rights Reserved.</div>
          </footer>
        </div>
        {window.region === "SG" && (
          <a
            className='whatsapp'
            target='_blank'
            href='https://api.whatsapp.com/send?phone=6587986867'
          >
            <img src={WhatsappIcon} />
          </a>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js